import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "frame", "error"]
  static values = { callbackUrl: String }

  connect() {
    this.boundHandleMessage = this.handleMessage.bind(this)
    window.addEventListener("message", this.boundHandleMessage)
  }

  disconnect() {
    window.removeEventListener("message", this.boundHandleMessage)
  }

  open() {
    this.hideError()
    this.dialogTarget.classList.remove("hidden")
    this.dialogTarget.classList.add("flex")
  }

  close() {
    this.dialogTarget.classList.add("hidden")
    this.dialogTarget.classList.remove("flex")
  }

  async handleMessage(event) {
    if (!this.hasFrameTarget || event.source !== this.frameTarget.contentWindow) return

    const payload = this.normalizedPayload(event.data)
    if (!payload || !this.looksLikeDuprPayload(payload)) return

    try {
      const response = await fetch(this.callbackUrlValue, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken()
        },
        body: JSON.stringify({ payload })
      })

      const body = await response.json()
      if (!response.ok) throw new Error(body.error || "DUPR sync failed.")

      window.location.reload()
    } catch (error) {
      this.showError(error.message)
    }
  }

  normalizedPayload(data) {
    if (typeof data === "string") {
      try {
        return JSON.parse(data)
      } catch (_error) {
        return null
      }
    }

    return data && typeof data === "object" ? data : null
  }

  looksLikeDuprPayload(payload) {
    const data = payload.data || payload.result || payload
    return Boolean(
      data.duprId ||
      data.dupr_id ||
      data.doublesRating ||
      (data.ratings && (data.ratings.doubles || data.ratings.singles))
    )
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }

  showError(message) {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("hidden")
  }

  hideError() {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = ""
    this.errorTarget.classList.add("hidden")
  }
}
